export const getAttachmentPreviewUrl = (attachmentId: string) => {
  const apiUrl = process.env.REACT_APP_MEDTECH_API_URL?.replace(
    /(^\w+:|^)/,
    '',
  );
  return `${apiUrl}/preview/${attachmentId}`;
};

export const getAttachmentUrl = (attachmentId: string, download = false) => {
  const apiUrl = process.env.REACT_APP_MEDTECH_API_URL?.replace(
    /(^\w+:|^)/,
    '',
  );
  // Note: MTBE generates redirect urls and defaults the download param to false if not provided
  return `${apiUrl}/attachments/${attachmentId}?download=${download}`;
};

/**
 * Returns an absolute URL suitable for copying/sharing. If the input is already
 * absolute it is returned unchanged; a relative path (i.e. /path/to/page) is
 * resolved against the current origin.
 */
export const toAbsoluteUrl = (str: string): string => {
  try {
    // Absolute URLs parse without a base; relative paths throw and fall through.
    return new URL(str).href;
  } catch (e) {
    return `${window.location.origin}${str.startsWith('/') ? '' : '/'}${str}`;
  }
};
